export const assertOptions = [
    { name: 'Sim', value: 'true' },
    { name: 'Não', value: 'false' }
  ]

export const assertBooleanOptions = [
    { name: 'Sim', value: true },
    { name: 'Não', value: false }
  ]